import Echo from "laravel-echo";
import socketio from "socket.io-client";

import { useEffect } from "react";
import { useWebsocket } from "@/stores/websocket";

export const useWs = (executedWhen=true) => {
    const setConnection = useWebsocket((state) => state.setConnection);
    useEffect(() => {
        if (executedWhen) {
            const conn = new Echo({
                client: socketio,
                broadcaster: "socket.io",
                host: import.meta.env.VITE_WEBSOCKET_URL
            });
            conn.connector.socket.on("connect", function () {
                // console.log("websocket connected...");
            });
            conn.connector.socket.on("disconnect", function () {
                // console.log("websocket disconnected...");
            });
            setConnection(conn);
            return () => conn.disconnect();
        }
    }, []);
};
